module.exports = __webpack_public_path__ + "static/media/lms.fafdf4a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lms.png
// module id = 1608
// module chunks = 0